/* ============================================================
   A marcação mínima dos textos longos

   Dois recursos e nada mais: `**negrito**` e `[texto](link)`. Quem
   desenha é cada plataforma — `<strong>` e `<a>` no site, `Txt` com peso
   e `Linking.openURL` no app —, e é por isso que a decisão do que cada
   pedaço É mora aqui, uma vez só.

   Por que não markdown de verdade: seriam duas implementações (ou uma
   dependência em cada lado) para renderizar dois documentos que usam
   negrito e um e-mail. O custo de manter um renderizador é maior que o
   do texto que ele renderiza.
   ============================================================ */

export interface Parte {
  txt: string;
  /** `**assim**` no texto. */
  forte?: boolean;
  /** `[assim](https://…)` no texto. */
  url?: string;
}

/**
 * Quebra um bloco nos pedaços que cada lado desenha.
 *
 * Devolve sempre pelo menos uma parte, e texto sem marcação nenhuma sai
 * como uma parte só — assim quem desenha não precisa de dois caminhos.
 */
export function partes(txt: string): Parte[] {
  const saida: Parte[] = [];
  /* Negrito OU link, na ordem em que aparecem. A alternância numa
     expressão só é o que mantém a ordem: dois passes (um por marca)
     fariam o segundo reescrever o texto já quebrado pelo primeiro. */
  const marca = /\*\*([\s\S]+?)\*\*|\[([^\]]+)\]\(([^)]+)\)/g;

  let ultimo = 0;
  let achado: RegExpExecArray | null;
  while ((achado = marca.exec(txt))) {
    if (achado.index > ultimo) saida.push({ txt: txt.slice(ultimo, achado.index) });
    if (achado[1] !== undefined) saida.push({ txt: achado[1], forte: true });
    else saida.push({ txt: achado[2]!, url: achado[3]! });
    ultimo = achado.index + achado[0].length;
  }
  if (ultimo < txt.length) saida.push({ txt: txt.slice(ultimo) });

  return saida.length ? saida : [{ txt }];
}
